/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ScheduledProposalCancellationsResponse model module.
 * @module model/ScheduledProposalCancellationsResponse
 * @version 1.0.0
 */
class ScheduledProposalCancellationsResponse {
    /**
     * Constructs a new <code>ScheduledProposalCancellationsResponse</code>.
     * @alias module:model/ScheduledProposalCancellationsResponse
     */
    constructor() { 
        
        ScheduledProposalCancellationsResponse.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ScheduledProposalCancellationsResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ScheduledProposalCancellationsResponse} obj Optional instance to populate.
     * @return {module:model/ScheduledProposalCancellationsResponse} The populated <code>ScheduledProposalCancellationsResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ScheduledProposalCancellationsResponse();

            if (data.hasOwnProperty('canceled_count')) {
                obj['canceled_count'] = ApiClient.convertToType(data['canceled_count'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ScheduledProposalCancellationsResponse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ScheduledProposalCancellationsResponse</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * 取り消した件数
 * @member {Number} canceled_count
 */
ScheduledProposalCancellationsResponse.prototype['canceled_count'] = undefined;






export default ScheduledProposalCancellationsResponse;

